var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.832 7.543a1.867 1.867 0 0 1 2.026-.403A1.86 1.86 0 0 1 30 8.852v15.106c0 1.016-.829 1.84-1.851 1.84H8.539l4.982-4.953 1.428 2.298h12.38V10.811l-7.452 7.399v-3.755l6.954-6.912zm-10.169 7.443-8.206 8.157h1.97l-2.67 2.655H2l14.166-14.08a1.867 1.867 0 0 1 2.026-.403c.69.283 1.142.952 1.142 1.703v9.585h-2.67v-7.617z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsd);
export default __webpack_public_path__ + "static/media/ASD.8d495f84d9238ff96d9e59ae48d08544.svg";
export { ForwardRef as ReactComponent };